import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../services/language.service';
import { DateHelper } from '../utils/date-helper';

@Pipe({
  name: 'eventoDayShort'
})
export class EventoDayShortPipe implements PipeTransform {

  constructor(private language: LanguageService) { }

  transform(value: string | Date, args?: any): string {
    return this.language.formatWeekdayShort(DateHelper.parseDateString(value));
  }

}
